import React from 'react';
import '../styles/loans.css';
import homeBg from "../images/transaction.gif";


const Loans = () => {
    return (
        <div className="loans-container" id="loans">
            <h2 className="loans-head">How Our Loan System Works</h2>

            {/* Hero Image */}
            <div className="loans-hero">
                <img
                    src={homeBg}
                    alt="Loan concept"
                />
            </div>

            <div className="loans-content">
                <p>
                    Our loan system is designed to offer you financial flexibility when you need it the most. Whether you're planning a big purchase, handling unexpected expenses, or consolidating debts, we provide a streamlined process to get you the funds you need quickly and easily.
                </p>

                {/* Steps */}
                <div className="loan-steps">
                    <div className="loan-step">
                        <h3>Step 1: Application</h3>
                        <p>
                            Start by filling out our simple online application form. Provide basic personal information, financial status, and the amount you wish to borrow. This helps us understand your needs and find the best loan options for you.
                        </p>
                    </div>

                    <div className="loan-step">
                        <h3>Step 2: Evaluation</h3>
                        <p>
                            Once we receive your application, our team conducts a thorough review. We evaluate your creditworthiness and repayment capacity to tailor a loan package that suits your requirements. Our goal is to offer competitive interest rates and flexible repayment terms.
                        </p>
                    </div>

                    <div className="loan-step">
                        <h3>Step 3: Disbursement</h3>
                        <p>
                            Upon approval, you'll receive a detailed loan agreement outlining the loan amount, interest rate, repayment schedule, and any fees involved. After agreeing to the terms, funds are promptly disbursed to your designated account.
                        </p>
                    </div>

                    <div className="loan-step">
                        <h3>Step 4: Repayment</h3>
                        <p>
                            We offer multiple repayment options to fit your financial situation. Our customer service team is always available to help with any questions or adjustments during the repayment period. Transparency and flexibility are the cornerstones of our loan service.
                        </p>
                    </div>
                </div>

                {/* Get Started */}
                <div className="loan-get-started">
                    <h3>Get Started Today</h3>
                    <p>
                        Ready to take the next step? To begin the loan process, send us an email with your full name, contact information, and a brief description of your loan needs. Our team will guide you through the next steps promptly.
                    </p>
                    <p>
                        We look forward to helping you achieve your financial goals with ease and confidence. Contact us today and take the first step toward financial freedom.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Loans;
